module.exports = "/lucky-balls/img/color_betting/black.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/color_betting/black.png
// module id = 976
// module chunks = 0